export default {"grid":"KpArn","offersTab":"o9AwS","sportsLandingPage":"E4c4-","card":"bXHJf"};